import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/landing-page/landing-page/components/pages/TermsPage.tsx");
